import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LOCAL_STORAGE, SESSION_STORAGE, StorageService, WebStorageService} from 'ngx-webstorage-service';

import {not} from 'rxjs/internal-compatibility';
import * as uuid from 'uuid';
import {AngularFireMessaging} from '@angular/fire/messaging';
import {DashboardService} from './dashboard.service';
import {AlertService} from 'ngx-alerts';
import {AuthenticationService} from '../account/auth/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  notifications: any[] = [];
  newNotificationsCount = '';
  loggedInUserData: any;

  constructor(private angularFireMessaging: AngularFireMessaging, @Inject(LOCAL_STORAGE) private storage: WebStorageService,
              @Inject(LOCAL_STORAGE) private localStorage: WebStorageService,
              private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.loggedInUserData = localStorage.get('gs-loggedInUserData');
    this.notifications = this.storage.get('gypsee_notifications');
    this.updateNewNotificationCount();
    this.storeToken();
    // this.angularFireMessaging.messages.subscribe((_messaging) => {
    //   _messaging.onMessage = _messaging.onMessage.bind(_messaging);
    //   _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
    // });
  }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        this.storage.set('gypsee_webFcmToken', token);
        this.storeToken();
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );

  }

  storeToken() {
    this.angularFireMessaging.getToken.subscribe(
      (res: any) => {
        if (res) {
          this.storage.set('gypsee_webFcmToken', res);
          let payload = {fcmToken: res};
          let params = {isWebToken: true};
          if (this.loggedInUserData) {
            this.authenticationService.updateUserFcmToken(this.loggedInUserData.userId, params, payload).subscribe(
              (res: any) => {

              }, error => {
                console.log(error);
                this.alertService.danger('Error While updating Notification Token.');
              }
            );
          }
        }
      }, error => {
        console.error(error);
      }
    );
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload: any) => {
      this.showCustomerNotification(payload);
      let notification = payload.data;
      notification['id'] = this.getUUID();
      notification['createdOn'] = new Date();
      // if (payload.data && payload.data['gcm.notification.data']) {
      //   notification['data'] = JSON.parse(payload.data['gcm.notification.data']);
      // }
      let notifications: any[] = [notification];
      if (this.storage.get('gypsee_notifications')) {
        for (let n of this.storage.get('gypsee_notifications')) {
          notifications.push(n);
        }
      }
      notifications.splice(5);
      // notifications.push(notification);
      this.notifications = notifications;
      this.storage.set('gypsee_notifications', notifications);
      this.updateNewNotificationCount();
    });
  }

  getUUID() {
    return uuid.v4().replace(/-/g, '').toUpperCase().replace('-', '');
  }

  updateNotification(notification) {
    let notifications: any[] = this.storage.get('gypsee_notifications');
    for (const n of notifications) {
      let index = notifications.indexOf(n);
      if (n && n['id'] == notification['id']) {
        notifications[index] = notification;
      }
    }
    this.notifications = notifications;
    this.storage.set('gypsee_notifications', notifications);
    this.updateNewNotificationCount();
  }

  showCustomerNotification(payload: any) {
    let notify_data = payload['data'];
    let title = notify_data['title'];
    let options = {
      body: notify_data['message'],
    };

    console.log('new message recived. ', notify_data);
    let notify: Notification = new Notification(title, options);

    notify.onclick = (e) => {
      e.preventDefault();
      // window.location.href = 'https://mydukanretailer.com/login';
    };
  }

  showNotification(payload: any) {
    let notify_data = payload['notification'];
    let title = notify_data['title'];
    let options = {
      body: notify_data['body'],
    };

    return notify_data;
  }

  private updateNewNotificationCount() {
    let notifications: any[] = this.storage.get('gypsee_notifications');
    if (notifications) {
      let count = notifications.filter(n => n && !n.isOpened).length;
      this.newNotificationsCount = count ? String(count) : '';
    }
  }

  public getTimeAgo(notification) {
    const SECOND = 1000;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;
    const WEEK = 7 * DAY;
    const MONTH = 30 * DAY;
    const YEAR = 365 * DAY;
    const units = [
      {max: 30 * SECOND, divisor: 1, past1: 'just now', pastN: 'just now', future1: 'just now', futureN: 'just now'},
      {max: MINUTE, divisor: SECOND, past1: 'a second ago', pastN: '# seconds ago', future1: 'in a second', futureN: 'in # seconds'},
      {max: HOUR, divisor: MINUTE, past1: 'a minute ago', pastN: '# minutes ago', future1: 'in a minute', futureN: 'in # minutes'},
      {max: DAY, divisor: HOUR, past1: 'an hour ago', pastN: '# hours ago', future1: 'in an hour', futureN: 'in # hours'},
      {max: WEEK, divisor: DAY, past1: 'yesterday', pastN: '# days ago', future1: 'tomorrow', futureN: 'in # days'},
      {max: 4 * WEEK, divisor: WEEK, past1: 'last week', pastN: '# weeks ago', future1: 'in a week', futureN: 'in # weeks'},
      {max: YEAR, divisor: MONTH, past1: 'last month', pastN: '# months ago', future1: 'in a month', futureN: 'in # months'},
      {max: 100 * YEAR, divisor: YEAR, past1: 'last year', pastN: '# years ago', future1: 'in a year', futureN: 'in # years'},
      {
        max: 1000 * YEAR,
        divisor: 100 * YEAR,
        past1: 'last century',
        pastN: '# centuries ago',
        future1: 'in a century',
        futureN: 'in # centuries'
      },
      {
        max: Infinity,
        divisor: 1000 * YEAR,
        past1: 'last millennium',
        pastN: '# millennia ago',
        future1: 'in a millennium',
        futureN: 'in # millennia'
      },
    ];
    const diff = Date.now() - (new Date(notification.createdOn)).getTime();
    const diffAbs = Math.abs(diff);
    for (const unit of units) {
      if (diffAbs < unit.max) {
        const isFuture = diff < 0;
        let x = Math.round(Math.abs(diff) / unit.divisor);
        if (x <= 1) {
          return isFuture ? unit.future1 : unit.past1;
        }
        return (isFuture ? unit.futureN : unit.pastN).replace('#', String(x));
      }
    }
  }

}
